import TurnoLaboralService from 'src/modules/turnoLaboral/turnoLaboralService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';
import TurnoLaboralListActions from 'src/modules/turnoLaboral/list/turnoLaboralListActions';

const prefix = 'TURNOLABORAL_FORM';

const turnoLaboralFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: turnoLaboralFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await TurnoLaboralService.find(id);
      }

      dispatch({
        type: turnoLaboralFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: turnoLaboralFormActions.INIT_ERROR,
      });

      getHistory().push('/turno-laboral');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: turnoLaboralFormActions.CREATE_STARTED,
      });

      await TurnoLaboralService.create(values);

      dispatch({
        type: turnoLaboralFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.turnoLaboral.create.success'),
      );

      // getHistory().push('/turno-laboral');

      dispatch(
        TurnoLaboralListActions.doFetchCurrentFilter(),
      );
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: turnoLaboralFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: turnoLaboralFormActions.UPDATE_STARTED,
      });

      await TurnoLaboralService.update(id, values);

      dispatch({
        type: turnoLaboralFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.turnoLaboral.update.success'),
      );

      // getHistory().push('/turno-laboral');

      dispatch(
        TurnoLaboralListActions.doFetchCurrentFilter(),
      );
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: turnoLaboralFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default turnoLaboralFormActions;
